import { NavMenuContentType } from '@hhgtech/hhg-components/components/navigationV2/index'

import SpotlightCarePathTemplate from 'components/templates/spotlight/carePath'
import { useIsMobile } from 'hooks/useIsMobile'
import {
  FooterInfo,
  HealthTool,
  SiteWideBanner,
  Spotlight,
  SpotlightTemplate,
} from 'interfaces/types'

export type Props = {
  page?: string
  spotlight: Spotlight
  footerInfo?: FooterInfo
  template?: SpotlightTemplate
  dataNavMenuContent?: NavMenuContentType
  pageType?: 'detail' | null
  sitewideBanner?: SiteWideBanner | null
}

const DynamicSpotlightPage = ({
  spotlight,
  footerInfo,
  dataNavMenuContent,
  pageType = null,
}: Props) => {
  const isMobile = useIsMobile()

  const healthTools = (dataNavMenuContent?.healthTools?.items ||
    []) as HealthTool[]

  return (
    <SpotlightCarePathTemplate
      key={`${spotlight.groupIdActive}-${spotlight.additionalSlugActive}`}
      isMobile={isMobile}
      spotlight={spotlight}
      healthTools={healthTools}
      pageType={pageType}
      footerInfo={footerInfo}
      dataNavMenuContent={dataNavMenuContent}
    />
  )
}

export { DynamicSpotlightPage }
